import { I18NService } from './services/i18n.service';
import { HttpClient } from '@angular/common/http';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA, ModuleWithProviders } from '@angular/core';
import { TranslateLoader, TranslateModule, TranslateService, TranslateStore } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '@ebw-monorepo/material';
import { ChangeLanguageComponent } from './change-language/change-language.component';

export function createTranslateLoader(http: HttpClient) {
  //This makes the admin and the portale-saas work
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    TranslateModule.forChild({
      defaultLanguage: 'it',
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      },
      extend: true,
      isolate: false
    })
  ],
  declarations: [ChangeLanguageComponent],
  exports: [TranslateModule, ChangeLanguageComponent],
  providers: [TranslateService, TranslateStore, I18NService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class I18NTranslateModule {
  static forRoot(): ModuleWithProviders<I18NTranslateModule> {
    return {
      ngModule: I18NTranslateModule,
      providers: [TranslateService, I18NService, TranslateStore]
    };
  }
}
